import { Component, OnInit } from "@angular/core";
import { PoModule, PoNotificationService, PoTableAction } from "@po-ui/ng-components";
import { Router } from "@angular/router";
import { EstoqueListService } from "./estoque-list.service";
import { PoPageFilter } from "@po-ui/ng-components";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-Estoque-list",
  templateUrl: "./estoque-list.component.html",
  styleUrls: ["./estoque-list.component.css"],
  standalone: false,
})
export class EstoqueListComponent implements OnInit {
  private filterModel: String;
  EstoqueList: Array<any> = new Array();
  columns: Array<any>;
  produto: String;

  public loading: boolean = true;

  public readonly filter: PoPageFilter = {
    action: this.showAction.bind(this, "Filter"),
    placeholder: "Filtra produto",
  };

  constructor(
    private EstoqueListService: EstoqueListService,
    private router: Router,
    private poNotification: PoNotificationService
  ) {}

  ngOnInit() {
    this.updateEstoqueList("");
    this.columns = this.EstoqueListService.getColumns();
    this.loading = false;
  }

  actions: Array<PoTableAction> = [
    {
      action: this.saldoEstoque.bind(this),
      icon: "po-icon po-icon-eye",
      label: "Saldo",
    },
  ];

  updateEstoqueList(filtro: String) {
    this.EstoqueListService.getEstoquesList(filtro).subscribe((response) => {
      this.EstoqueList = response;
    });
  }

  saldoEstoque(item) {
    this.EstoqueListService.getEstoque(
      this.EstoqueList[this.EstoqueList.indexOf(item)].codigo
    ).subscribe((estoque) => {
      this.EstoqueList[this.EstoqueList.indexOf(item)].estoque =
        estoque.QUANTIDADE;
    });
  }

  showAction(label) {
    this.updateEstoqueList(this.filterModel);
  }

  buscaProduto() {
    this.updateEstoqueList(this.produto);
  }
}
